import http from '@/utils/http' //引入axios
export const getplatform = data => http.get('/kg-payment/api/platform', {
    params: data
})
export const addplatform = data => http.post('/kg-payment/api/platform', data)
export const updataplatform = data => http.put('/kg-payment/api/platform', data)
export const deleteplatform = data => http.delete('/kg-payment/api/platform', {
    params: data
})
export const exportCord = data => http.get('/rvm-center/api/transaction/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getplatform,
    addplatform,
    updataplatform,
    deleteplatform,
    exportCord
}